import { lazy, Suspense } from "react";
import { AppLoader } from "./AppLoader";
import { AuthenticationProvider } from "@certa/auth/AuthenticationProvider";
import { isNewAuthFlow } from "@certa/auth/directAuthActions";
// New architecture: React Query + Context (no Redux)
const NewAppRouter = lazy(() =>
  import("@certa/auth/AppRouterV2").then(module => ({
    default: module.AppRouterV2
  }))
);
// Legacy architecture: Redux + Godaam (unchanged)
const LegacyAppRouter = lazy(() =>
  import("./AppRouterLegacy").then(module => ({
    default: module.AppRouterLegacy
  }))
);

/**
 * Main AppRouter that decides between legacy and new architecture
 * This is lazy-loaded at the routing level and uses the existing queryClient from App.tsx
 */
export const AppRouter = () => {
  const isNewAuthFlowEnabled = isNewAuthFlow();

  if (isNewAuthFlowEnabled) {
    return (
      <Suspense fallback={<AppLoader />}>
        <AuthenticationProvider>
          <NewAppRouter />
        </AuthenticationProvider>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<AppLoader />}>
      <AuthenticationProvider>
        <LegacyAppRouter />
      </AuthenticationProvider>
    </Suspense>
  );
};
